import { gameSignals } from '@/bridge/gameSignals';
import { t } from '@/i18n';
import { computeBadges, BADGES } from '@/lib/badges';

export function ResultSummary() {
  const record = gameSignals.record.value;
  const streak = gameSignals.streak.value;
  if (!record) return null;
  const current = streak?.current ?? 0;
  const showWelcomeChip = current === 1 || current === 2;
  const showStreakChip = current >= 3;

  const badges = computeBadges(record.shots);
  const todayAvg = gameSignals.todayAverage.value;
  const communityVisible = (gameSignals.todayPlayerCount.value ?? 0) >= 20;

  return (
    <section class="mx-auto max-w-[22rem] px-4 card-deal">
      <div class="result-card">
        <div class="result-card-inner px-5 py-3">
          <div class="relative z-10 flex items-center justify-between">
          <span class="font-mono text-[10px] uppercase tracking-[0.22em] text-text-2">
            {t('result.scoreLabel')}
          </span>
          {showWelcomeChip && streak && (
            <span class="font-mono text-[11px] uppercase tracking-[0.18em] text-foil flex items-center gap-1.5">
              <span class="not-italic">{current === 1 ? '🥚' : '🐣'}</span>
              <span>{t(current === 1 ? 'result.day1Welcome' : 'result.day2Welcome')}</span>
            </span>
          )}
          {showStreakChip && streak && (
            <span class="font-mono text-[11px] uppercase tracking-[0.18em] text-streak flex items-center gap-1.5">
              <span class="not-italic">🔥</span>
              <span>{streak.current}.</span>
              <span class="opacity-80">{t('result.streakDays')}</span>
              {streak.graceUsed && <span class="ml-0.5">🛡️</span>}
            </span>
          )}
        </div>
          <div class="relative z-10 mt-2 text-center">
            <span class="score-pop font-display text-[3.5rem] leading-none text-text">
              {record.score}<span class="font-mono text-xl text-text-dim ml-1">/{record.shots.length}</span>
            </span>
          </div>
          <div class="mt-2.5 flex flex-col gap-2 items-center">
            {communityVisible && todayAvg !== null && (
              <span class="font-mono text-[10px] text-text-2">
                {t('result.communityLine', { self: String(record.score), avg: todayAvg.toFixed(1) })}
              </span>
            )}
            {badges.length > 0 && (
              <div class="flex gap-1.5 flex-wrap justify-center">
                {badges.map((id) => {
                  const meta = BADGES.find((b) => b.id === id)!;
                  return (
                    <span class="badge-chip foil-text font-mono text-[10px] px-2 py-1 rounded-full border border-foil/40">
                      {meta.emoji} {t(meta.i18nKey as never)}
                    </span>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
